import React, {useContext} from 'react';
import {useLocation} from "react-router";
import {AuthContext, Layout as MlibLayout, useAppVersion} from "@lb/mlib-components";
import PagesMenu from "./PagesMenu";
import SettingsActions from "./SettingsActions";
import MySearch from "./MySearch";
import AppHeader from "./AppHeader";
import logo from "../../pages/home/LongboardColourLogo.png";
import {Tooltip} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import RefreshIcon from "@mui/icons-material/Refresh";

const Layout = ({callLoad, children}) => {
    const authCtx = useContext(AuthContext);
    const location = useLocation();
    const version = useAppVersion();
    const {build} = window['runConfig'];

    // Dashboard/kiosk routes render their own full-screen chrome (see DashboardShipments),
    // so the regular header/drawer shell is skipped entirely for them.
    const isDashboard = location.pathname.startsWith('/dashboard');

    if (!authCtx.isLoggedIn() || isDashboard) {
        return <>{children}</>;
    }

    return (
        <MlibLayout
            build={build}
            version={version}
            drawer={<PagesMenu/>}
            appBar={<AppHeader
                logo={logo}
                logoAlt="Ziggy"
                logoActions={<MySearch/>}
                barActions={
                    <Tooltip title="Refresh">
                        <IconButton color="inherit" onClick={callLoad}>
                            <RefreshIcon/>
                        </IconButton>
                    </Tooltip>
                }
                settingsActions={<SettingsActions/>}
            />}
        >
            {children}
        </MlibLayout>
    );
};

export default Layout;
